const alias = 'DEAL'

export const GET_DEAL_DETAILS_REQUEST = `GET_${alias}_DETAILS_REQUEST`;
export const GET_DEAL_DETAILS_SUCCESS = `GET_${alias}_DETAILS_SUCCESS`;
export const GET_DEAL_DETAILS_FAILURE = `GET_${alias}_DETAILS_FAILURE`;

export const RESET_DEAL_STATE = `RESET_${alias}_STATE`;
